export enum EEmitentZadaOpridISIN {
    LISTINNY = 'LIST',
    ZAKNIHOVANY = 'ZAKN',
    IMOBILIZOVANY = 'IMOB',
    LISTSBER = 'SBER'
}
